// extracted by mini-css-extract-plugin
module.exports = {"link":"Logo_link__3YsEY","logo":"Logo_logo__1qerg"};